// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> the-nolan
// Generated: 2026-10-22T20:05:12.174Z
// Counts: 5 design, 66 content, 60 slot group, 1 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Your Blissful Life at Our Charming Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Nolan offers recently upgraded one and two bedroom apartments in Morrisville, Pennsylvania, with the amenities and extras that make your life comfortable and easy. Enjoy a pet-friendly community with beautifully landscaped grounds and ample parking, as well as a fully equipped kitchen and in-unit washer and dryer. Our upgraded community is conveniently located near popular dining, outdoor recreation, and shopping, so your next-level living experience extends far beyond your front door.</p><p>Discover the excellence that’s waiting for you. Find your perfect floor plan and reach out to a leasing consultant today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>See <span data-type=\"field-token\" data-field=\"property_name\"></span> in person</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour the community from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Nolan in Morrisville, PA, you’ll relish the tranquil park-like setting complemented by beautifully landscaped grounds. Choose from spacious one and two-bedroom floor plans, enjoy pet-friendly amenities, and embrace modern comforts like in-unit washers and new stainless steel kitchens. Your dream apartment awaits—connect with us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Nolan in Morrisville, PA, you’ll find spacious one and two-bedroom apartments nestled in beautifully landscaped grounds, just minutes from Route 1 and I-95. Enjoy pet-friendly living, modern amenities, and the convenience of online rent payments. Experience comfort and style—apply now to make The Nolan your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Nolan in Morrisville, PA, your ideal space awaits! Choose from spacious one and two-bedroom layouts designed for comfort and style. Each floor plan is thoughtfully crafted to suit your lifestyle. Browse our available apartment homes today and step into a new chapter of elevated living!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Nolan in Morrisville, PA, picture your life in spacious, beautifully designed one or two-bedroom apartments surrounded by park-like grounds. Enjoy modern amenities, pet-friendly policies, and convenient access to Route 1 and I-95. Explore our photo gallery and envision a vibrant lifestyle waiting for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "The Nolan",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy our newly updated one- and two- bedroom apartment homes for rent in Morrisville, PA.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Nolan, your serene oasis in Morrisville, PA! Live comfortably in our spacious one and two-bedroom floor plans, and enjoy easy access to vibrant community attractions. With parks, schools, and cultural gems like the Bucks County Playhouse just moments away, you’ll savor both convenience and charm at your doorstep.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Nolan in Morrisville, PA, where comfort meets convenience. Whether you choose a cozy one-bedroom or a spacious two-bedroom layout, you'll find the perfect home that fits your lifestyle. Access your resident portal today to effortlessly manage rent payments, schedule maintenance, and enjoy all the amenities we offer!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out! At The Nolan in Morrisville, PA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Our team will be in touch soon to help you find your perfect home in our welcoming community. Stay tuned for a response!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-195c-7643-8336-23412c38e5c1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment bedroom with a built-in closet, laminate flooring, and a window with blinds."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-236b-7429-8eba-de2ea0331e7d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "In-unit laundry closet with a white washer and dryer for resident use."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-7a05-706d-9528-c6ef28cfecc9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a sliding glass door, sofa, armchair, rug, coffee table, TV, and a potted plant."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-ee0b-733b-a9e7-0fc6aa5ae91e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room in an apartment with a white sofa, armchair, coffee tables, plants, and sliding balcony door."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-1fc7-724b-9eb6-01a74837ab42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with beige sofa, coffee table, TV stand, and sliding glass door with blinds."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-64a6-75bc-89fa-f3c17b3cccd8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with a white sofa, chair, and sliding balcony door."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-28f1-732d-a969-690396cf921e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets, granite countertops, stainless steel stove and refrigerator."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-2b11-76fd-981b-766c82aa06fc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry closet with a white washer and dryer side by side"
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166354/019d026d-10ed-7393-ba17-26e616a05215.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Nearby Trenton Makes bridge over the Delaware River with the city skyline behind."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-10ed-7393-ba17-26e616a05215.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wide river with a green metal truss bridge and city skyline under a blue, cloud-filled sky."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-48e3-74d1-8801-8b2e34980ed2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multi-building apartment complex with central green space and trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-7b07-74b1-9f99-6294faac617b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial cityscape with a river, a steel bridge, and downtown buildings under a blue sky."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-25d0-76db-80c7-390e131e7aa9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Landscaped community courtyard with a green lawn and mature trees between apartment buildings."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-f562-74bc-935a-0602ff0e107c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a green lawn and winding sidewalk."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-5635-7714-80f9-9d5f5cfa870c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment building with white brick base, brown shingled upper facade, and landscaped lawn"
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-21cf-70d5-9035-f65caf8a52a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a two-story apartment building with blue doors, a green lawn, and surrounding trees."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_optional": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Insurance"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$14"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$300"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent — 2nd Pet"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.storage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Storage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$20"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Varies"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-7a05-706d-9528-c6ef28cfecc9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a sliding glass door, sofa, armchair, rug, coffee table, TV, and a potted plant."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026d-ee0b-733b-a9e7-0fc6aa5ae91e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room in an apartment with a white sofa, armchair, coffee tables, plants, and sliding balcony door."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-64a6-75bc-89fa-f3c17b3cccd8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with a white sofa, chair, and sliding balcony door."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019d026c-28f1-732d-a969-690396cf921e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets, granite countertops, stainless steel stove and refrigerator."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-9bbd-7624-9335-5389007d4299.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Dunkin'"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Coffee"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Long-running chain serving signature breakfast items & a variety of coffee drinks."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-fc01-737b-a65d-1a37f058227d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Oxford Valley Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-602f-72d9-aea6-6b52ddafa258.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Williamson Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Large park for riverfront views and baseball and softball fields and shows, plus playgrounds."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-9e22-718a-999b-3ac38acbf5c7.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Edgewood Cafe"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual cafe for breakfast and lunch with coffee, sandwiches, and other comfort food, plus kids' options."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-0e81-70d8-8bc5-80d471b09d4c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bucks County Children's Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "8.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Hands-on children's museum with interactive exhibits exploring local history, science, and imaginative play. Advance ticketing recommended."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-8c6d-7518-8c0f-bfafd07bd49b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Delaware Canal Morrisville Trailhead"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Peaceful trail along the Delaware River with views of fish, birds, turtles and deer."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-0fce-775f-8f1f-1d33a9cf54c4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Morrisville Tavern"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Longtime neighborhood bar and restaurant featuring regular live music, karaoke, trivia nights, and pool tables."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1e13-707a-848b-364d6a69a870.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Triumph Restaurant & Brewery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Eatery & bar's grand, industrial space offers craft beers, burgers, fish 'n' chips & small plates."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-aeb3-7729-a81f-b2b93948fe3f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Trattoria Rosa Bianca"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Family-run Italian BYOB in a historic, quaint Victorian home with seasonal outdoor dining."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-b827-760f-a5ee-c5c1a05e00fa.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Vault Brewing Company"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Hip, speakeasy-style bar keeps its brewery in plain view & serves up craft beer, tapas & jazz."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd930-1bc9-779c-b90b-ffe1617ad699.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bucks County Playhouse"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Theater & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Former gristmill is now a theater space for musical revivals, dramas, children's shows & live music."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd92f-ce94-701f-9f19-e1f3f02ba24e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Panna Gelateria And Bakery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dessert & Sweets"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Charming, family-run dessert spot dishing up homemade gelato and rich hot chocolate in a fun atmosphere."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0d7d-7563-aaad-0fdc4f67762a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a sliding glass door, sofa, armchair, rug, coffee table, TV, and a potted plant."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-0d15-73bc-af53-9943fc1f6d2f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in a modern apartment with a gray bed, yellow accent pillows, white dresser, and a tall plant."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166354/019fd931-2882-766a-88d6-8e5b34fd3fe8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a green lawn and winding sidewalk."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
